import TypeWindow from './type-window';

export default TypeWindow;